var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11_2)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M15.0937 19.8125C12.9969 19.8125 10.9859 18.9795 9.50319 17.4968C8.02048 16.0141 7.1875 14.0031 7.1875 11.9063C7.1875 9.80938 8.02048 7.7984 9.50319 6.31569C10.9859 4.83298 12.9969 4 15.0938 4L15.0937 19.8125Z",
    fill: "#6A69F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8125 22.2813L15.8125 0.71875C15.8125 0.528126 15.7368 0.345309 15.602 0.210517C15.4672 0.0757252 15.2844 -2.30851e-08 15.0938 -3.14176e-08C12.0438 -1.64737e-07 9.11869 1.2116 6.96202 3.36827C4.80535 5.52494 3.59375 8.45001 3.59375 11.5C3.59375 14.55 4.80535 17.4751 6.96202 19.6317C9.11869 21.7884 12.0438 23 15.0937 23C15.2844 23 15.4672 22.9243 15.602 22.7895C15.7368 22.6547 15.8125 22.4719 15.8125 22.2813ZM9.53152 6.95391L13.3589 10.7813L7.94219 10.7813C8.08255 9.37655 8.63556 8.04483 9.53152 6.95391ZM10.5477 5.93777C11.6386 5.04181 12.9703 4.4888 14.375 4.34844L14.375 9.76512L10.5477 5.93777ZM13.3589 12.2188L9.53152 16.0461C8.63556 14.9552 8.08255 13.6234 7.94219 12.2188L13.3589 12.2188ZM10.5477 17.0622L14.375 13.2349L14.375 18.6516C12.9703 18.5112 11.6386 17.9582 10.5477 17.0622ZM5.03125 11.5C5.03428 8.95651 5.99913 6.50827 7.73217 4.64657C9.46522 2.78488 11.8382 1.64749 14.375 1.46266L14.375 2.90555C12.2207 3.08734 10.2133 4.07155 8.75022 5.66325C7.28718 7.25495 6.47526 9.33806 6.47526 11.5C6.47526 13.6619 7.28718 15.745 8.75022 17.3367C10.2133 18.9285 12.2207 19.9127 14.375 20.0945L14.375 21.5373C11.8382 21.3525 9.46522 20.2151 7.73217 18.3534C5.99913 16.4917 5.03428 14.0435 5.03125 11.5Z",
    fill: "#6A69F5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "white",
    transform: "translate(23) rotate(90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcon);
export default __webpack_public_path__ + "static/media/logo-icon.5403f002e545de681e3df62fd463d5a5.svg";
export { ForwardRef as ReactComponent };